import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./slices/modalSlice";
import authReducer, { logout } from './slices/authSlice';
import clientsReducer from "./slices/clientsSlice";
import clientDetailReducer from "./slices/clientDetailSlice";
import selectedClientReducer from "./slices/selectedClientSlice";
import statesReducer from "./slices/statesSlice"
import industriesReducer from "./slices/industrySlice"
import banksReducer from "./slices/bankSlice"
import categoriesReducer from "./slices/categorySlice";
import { apiClient } from "src/api/client";

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    auth: authReducer,
    clients: clientsReducer,
    clientDetail: clientDetailReducer,
    selectedClient: selectedClientReducer,
    states: statesReducer,
    industries: industriesReducer,
    banks: banksReducer,
    categories: categoriesReducer,
  },
});

apiClient.setLogoutCallback(() => {
  store.dispatch(logout());
  window.location.href = "/login";
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;